import styled from 'styled-components';


export const Grouper = styled.div`
	display: grid;
	gap: ${({gap}) => gap || 0}px;
`;
